import React, { useState, useEffect } from "react";
import InputDropdown from "../../../../../components/inputs/inputDropdown/inputDropdown";
import { HiOutlineHome, HiOutlineCube, HiOutlineColorSwatch, HiOutlineLightBulb, HiOutlineVolumeUp, HiOutlineSparkles } from "react-icons/hi";
import "./comparativa.scss";

const Comparativa = () => {
    const [versionBase, setVersionBase] = useState({ label: "Actual", value: "actual" });
    const [versionComparar, setVersionComparar] = useState(null);

    // Opciones de versiones disponibles para comparar
    const versionesOptions = [
        { label: "VersiónMC 24032026_1524 - 24/03/2026 15:2", value: "v24032026_1524" },
        { label: "VersiónMC 23032026_1430 - 23/03/2026 14:30", value: "v23032026_1430" },
        { label: "VersiónMC 22032026_1615 - 22/03/2026 16:15", value: "v22032026_1615" },
        { label: "VersiónMC 21032026_0900 - 21/03/2026 09:00", value: "v21032026_0900" },
        { label: "VersiónMC 20032026_1745 - 20/03/2026 17:45", value: "v20032026_1745" }
    ];

    // Datos de las categorías con sus valores
    const [datosComparativa, setDatosComparativa] = useState({
        mobiliarioGeneral: { 
            actual: 246502.65, 
            anterior: 246502.67, 
            icono: <HiOutlineHome />
        },
        mobiliarioEspecial: { 
            actual: 155369.21, 
            anterior: 155369.21, 
            icono: <HiOutlineCube />
        },
        suelosTarkett: { 
            actual: 0.00, 
            anterior: 0.00, 
            icono: <HiOutlineColorSwatch />
        },
        revestimientosMobiliario: { 
            actual: 6660.46, 
            anterior: 6660.45, 
            icono: <HiOutlineSparkles />
        },
        audiovisuales: { 
            actual: 469822.21, 
            anterior: 469822.21, 
            icono: <HiOutlineVolumeUp />
        },
        iluminacion: { 
            actual: 1161607.14, 
            anterior: 1161607.14, 
            icono: <HiOutlineLightBulb />
        }
    });

    // Calcular totales
    const calcularTotales = () => {
        const totalActual = Object.values(datosComparativa).reduce((sum, item) => sum + item.actual, 0);
        const totalAnterior = Object.values(datosComparativa).reduce((sum, item) => sum + item.anterior, 0);
        const diferencia = totalActual - totalAnterior;
        const porcentaje = totalAnterior !== 0 ? ((diferencia / totalAnterior) * 100) : 0;

        return { totalActual, totalAnterior, diferencia, porcentaje };
    };

    // Calcular diferencia y porcentaje para cada categoría
    const calcularDiferencia = (actual, anterior) => {
        const diferencia = actual - anterior;
        const porcentaje = anterior !== 0 ? ((diferencia / anterior) * 100) : (actual > 0 ? 100 : 0);
        return { diferencia, porcentaje };
    };

    // Formatear número con separadores de miles
    const formatearNumero = (numero) => {
        return numero.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // Formatear porcentaje
    const formatearPorcentaje = (porcentaje) => {
        return `${porcentaje.toFixed(0)}%`;
    };

    // Obtener clase CSS para diferencias
    const getClaseDiferencia = (diferencia) => {
        if (diferencia > 0) return "positive";
        if (diferencia < 0) return "negative";
        return "neutral";
    };

    // Simulación de actualización de datos cuando se cambia la versión
    useEffect(() => {
        if (versionComparar) {
            // Aquí iría la lógica para cargar datos de la versión seleccionada
            // Por ahora simulamos pequeñas diferencias
            const factorCambio = Math.random() * 0.02 - 0.01; // Cambio entre -1% y +1%
            
            setDatosComparativa(prev => ({
                mobiliarioGeneral: {
                    ...prev.mobiliarioGeneral,
                    anterior: prev.mobiliarioGeneral.actual * (1 + factorCambio)
                },
                mobiliarioEspecial: {
                    ...prev.mobiliarioEspecial,
                    anterior: prev.mobiliarioEspecial.actual * (1 + factorCambio * 0.5)
                },
                suelosTarkett: {
                    ...prev.suelosTarkett,
                    anterior: 0
                },
                revestimientosMobiliario: {
                    ...prev.revestimientosMobiliario,
                    anterior: prev.revestimientosMobiliario.actual * (1 + factorCambio * 0.3)
                },
                audiovisuales: {
                    ...prev.audiovisuales,
                    anterior: prev.audiovisuales.actual
                },
                iluminacion: {
                    ...prev.iluminacion,
                    anterior: prev.iluminacion.actual
                }
            }));
        }
    }, [versionComparar]);

    const totales = calcularTotales();

    return (
        <div className="comparativa-versiones">            
            <div className="comparativa-versiones__seleccion">
                <div className="version-selector">
                    <label>Versión base</label>
                    <InputDropdown
                        options={[{ label: "Actual", value: "actual" }]}
                        onSelect={setVersionBase}
                        value={versionBase}
                        placeholder="Actual"
                        disabled={true}
                    />
                </div>
                
                <div className="version-selector">
                    <label>Versión comparar</label>
                    <InputDropdown
                        options={versionesOptions}
                        onSelect={setVersionComparar}
                        value={versionComparar}
                        placeholder="Selecciona una versión"
                        hasSearch={false}
                    />
                </div>
                
                <div className="version-selector">
                    <label>Desviación</label>
                    <div className="desviacion-display">
                        <span>{formatearNumero(totales.diferencia)}€</span>
                    </div>
                </div>
            </div>

            <div className="comparativa-versiones__resumen">
                <div className="resumen-col">
                    <div className="resumen-item">
                        <span className="label">Total</span>
                        <span className="valor">{formatearNumero(totales.totalActual)}€</span>
                    </div>
                    <div className="resumen-item">
                        <span className="label">Porcentaje</span>
                        <span className="valor">-</span>
                    </div>
                </div>
                
                <div className="resumen-col">
                    <div className="resumen-item">
                        <span className="label">Total</span>
                        <span className="valor">{formatearNumero(totales.totalAnterior)}€</span>
                    </div>
                    <div className="resumen-item">
                        <span className="label">Porcentaje</span>
                        <span className="valor">-</span>
                    </div>
                </div>
                
                <div className="resumen-col">
                    <div className="resumen-item">
                        <span className="label">Total</span>
                        <span className="valor">{formatearNumero(totales.diferencia)}€</span>
                    </div>
                    <div className="resumen-item">
                        <span className="label">Porcentaje</span>
                        <span className="valor">{formatearPorcentaje(totales.porcentaje)}</span>
                    </div>
                </div>
            </div>

            <div className="comparativa-versiones__tabla">
                <div className="tabla-header">
                    <div className="columna categoria">Categoría</div>
                    <div className="columna">Actual</div>
                    <div className="columna">Anterior</div>
                    <div className="columna">Diferencia</div>
                    <div className="columna">% Variación</div>
                </div>

                {Object.entries(datosComparativa).map(([key, data]) => {
                    const { diferencia, porcentaje } = calcularDiferencia(data.actual, data.anterior);
                    const nombreCategoria = {
                        mobiliarioGeneral: "Mobiliario General",
                        mobiliarioEspecial: "Mobiliario Especial", 
                        suelosTarkett: "Suelos Tarkett",
                        revestimientosMobiliario: "Revestimientos Mobiliario",
                        audiovisuales: "Audiovisuales",
                        iluminacion: "Iluminación"
                    };

                    return (
                        <div key={key} className="tabla-fila">
                            <div className="columna categoria">
                                {data.icono}
                                <span>{nombreCategoria[key]}</span>
                            </div>
                            <div className="columna">{formatearNumero(data.actual)}€</div>
                            <div className="columna">{formatearNumero(data.anterior)}€</div>
                            <div className={`columna ${getClaseDiferencia(diferencia)}`}>
                                {diferencia >= 0 ? '+' : ''}{formatearNumero(diferencia)}€
                            </div>
                            <div className={`columna ${getClaseDiferencia(diferencia)}`}>
                                {formatearPorcentaje(porcentaje)}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Comparativa;